import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { required, minLength8, normalizeAccount } from '../../../utilities/validation';
import { TextField } from '../../fields';
import messages from '../../../text/messages';
import { bankRoutingFieldLabel, bankRoutingFieldNormalize, bankRoutingFieldValidate, checkingAccountFieldLabel } from '../../../utilities/regime';

const Bank = ({ fieldsOptions, disabled, manuallyValidated, regime }) => {
    const { bankName, bankRouting, bankAccount } = fieldsOptions || {};
    return (
        <div>
            <div className="row">
                <div className={bankName && bankName.size ? bankName.size : 'col-xs-12 col-sm-8'}>
                    <Field
                        name={bankName && bankName.name ? bankName.name : 'bankName'}
                        validate={manuallyValidated ? undefined : required}
                        component={TextField}
                        placeholder={messages.bankName}
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className="row">
                <div className={bankRouting && bankRouting.size ? bankRouting.size : 'col-xs-12 col-sm-8'}>
                    <Field
                        name={bankRouting && bankRouting.name ? bankRouting.name : 'bankRouting'}
                        validate={manuallyValidated ? undefined : bankRoutingFieldValidate(regime)}
                        component={TextField}
                        placeholder={bankRoutingFieldLabel(regime)}
                        normalize={bankRoutingFieldNormalize(regime)}
                        disabled={disabled}
                    />
                </div>
                <div className={bankAccount && bankAccount.size ? bankAccount.size : 'col-xs-12 col-sm-8'}>
                    <Field
                        name={bankAccount && bankAccount.name ? bankAccount.name : 'checkingAccount'}
                        validate={manuallyValidated ? undefined : minLength8}
                        component={TextField}
                        placeholder={checkingAccountFieldLabel(regime)}
                        normalize={normalizeAccount}
                        disabled={disabled}
                    />
                </div>
            </div>
        </div>
    );
};

Bank.propTypes = {
    fieldsOptions: PropTypes.object,
    regime: PropTypes.object,
    disabled: PropTypes.bool
};

export default Bank;



// WEBPACK FOOTER //
// ./src/components/forms/bank/index.jsx